export const EXCHANGE_ROUTES = {
    passengers: '/exchange',
    segments: '/exchange/segments',
    flights: '/exchange/flights',
    request: '/exchange/request'
};
export const EXCHANGE_ROUTES_MAP = new Map([
    [EXCHANGE_ROUTES.passengers, { next: EXCHANGE_ROUTES.segments, prev: null }],
    [EXCHANGE_ROUTES.segments, { next: EXCHANGE_ROUTES.flights, prev: EXCHANGE_ROUTES.passengers }],
    [EXCHANGE_ROUTES.flights, { next: EXCHANGE_ROUTES.request, prev: EXCHANGE_ROUTES.segments }],
    [EXCHANGE_ROUTES.request, { next: null, prev: EXCHANGE_ROUTES.flights }]
]);
